// extracted by mini-css-extract-plugin
export default {"banner_section":"banner_banner_section__DEjdC","banner":"banner_banner__VB2nr","text_banner":"banner_text_banner__jqAnY","banner_btn":"banner_banner_btn__DXilJ"};